export default {
  path: "/user/cpa/clasificados",
  component: () => import("@/views/user/cpa/clasificados/ClasificadosLayout.vue"),
  meta: {
    requiresAuth: true,
    requiresCurso: true,
    requiresCpaDirectiva: true,
  },
  children: [
    {
      path: "",
      name: "clasificados-moderacion",
      component: () =>
        import("@/views/user/cpa/clasificados/ClasificadosModeracionView.vue"),
    },
  ],
};
